import { Box, Card, formatDate, getSpacing, Grid, Stack, Typography, useElementBreakpoints } from "@compass/core";
import { Home, HomeMatchDashboard } from "generated/openApi";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";

import { DashboardPieChart } from "./DashboardPieChart";
import { DashboardTable } from "./DashboardTable";

export const MatchDashboard = () => {
  const { breakpointsRef, setBreakpoints } = useElementBreakpoints();
  const [dashboard, setDashboard] = useState<HomeMatchDashboard>();
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    fetch();
  }, []);

  const fetch = () => {
    ApiService.home.getMatchDashboard().then((response) => {
      setDashboard(response);
      setLoading(false);
    });
  };

  return (
    <Card header={"Overall Match Contribution"}>
      <Grid ref={breakpointsRef} container spacing="lg">
        <Grid item xs={setBreakpoints({ md: 8, xs: 12 })}>
          <Stack width="90%" height="100%" direction="row" justifyContent={"center"} alignItems="center">
            <DashboardPieChart rows={dashboard?.pieChartRows} loading={loading} />
          </Stack>
        </Grid>

        <Grid item xs={setBreakpoints({ md: 4, xs: 12 })}>
          <DashboardTable rows={dashboard?.tableRows} loading={loading} />
        </Grid>
      </Grid>

      <Box pt={getSpacing("lg")}>
        <Typography variant="caption">
          Report dates: {formatDate(dashboard?.reportDateFrom)}
          <> to </>
          {formatDate(dashboard?.reportDateTo)}
        </Typography>
      </Box>
    </Card>
  );
};
